import Vue from "vue";
import Vuex from "vuex";

import * as user from "@/store/modules/user";
import * as ligas from "@/store/modules/ligas";
import * as equipos from "@/store/modules/equipos";
import * as partidos from "@/store/modules/partidos";
import * as notification from "@/store/modules/notification";
import * as torneos from "@/store/modules/torneos";
import * as quinielas from "@/store/modules/quinielas";
import * as jugadores from "@/store/modules/jugadores";
import * as estadistica from "@/store/modules/estadistica";
import * as login from "@/store/modules/login";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {
    logout({ commit }) {
      commit("user/CLEAR_USER_DATA");
    }
  },
  getters: {
    loggedIn(state) {
      return !!state.user.user;
    }
  },
  modules: {
    user,
    ligas,
    notification,
    equipos,
    partidos,
    torneos,
    quinielas,
    jugadores,
    estadistica,
    login
  }
});
